import { useEffect, useState } from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { useTenantIdFromParams } from '@eluve/session-helpers';

type Location = {
  id: string;
  name: string;
};

export const useTenantLocations = ({
  skip = false,
}: { skip?: boolean } = {}) => {
  const apiClient = useApiClient();
  const tenantId = useTenantIdFromParams();
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    if (!skip && tenantId) {
      (async () => {
        const locationsResponse = await apiClient.locations.getLocations({
          params: {
            tenantId,
          },
        });
        if (locationsResponse.status === 200) {
          setLocations(locationsResponse.body.locations);
        }
      })();
    }
  }, [apiClient, skip, tenantId]);

  return { locations };
};
